// @ts-nocheck
import { axiosHelper } from 'Services/AxiosHelper';
import { LoginWithOpenIdBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.MBLoginWithOpenId';

const loginWithOpenId = async (params: LoginWithOpenIdBodyData): Promise<any> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default loginWithOpenId;
